<div class="button-container">
  <gc-button [variant]="'secondary'" (clicked)="cancel.emit()">{{
    'reportInput.cancel' | translate
  }}</gc-button>
  <gc-button [disabled]="disableSaveButton" (clicked)="save.emit()">{{
    'reportInput.save' | translate
  }}</gc-button>
</div>
